<div class="container">
    <img src="./assets/img/howto-gene-table.png" width="80%">
  <img src="./assets/img/howto-gene-browser.png" width="80%">

</div>
